import React, {useState, useEffect, useContext, useRef} from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import Attachment from '@material-ui/icons/Attachment';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MyDailogModal from '../Commons/myDailogModal';
import DnD from '../Commons/Drag_n_Drop';
import {TextInput, StyledButton2, StyledCircularProgress, CheckboxInput} from '../Commons/styledTabs';
import {RemittanceContext, devConsolelog, postApi, AppContext, getFileNameFromUrl} from '../../Utility';
import {
  API_DOCSUMO_PAN, API_DOCSUMO_PASSPORT_FRONT, DOCSUMO_APIKEY, API_SECTION_REMITT_TRAVELERS,
  API_DOMAIN_URL_RESELLER, API_SECTION_RESELLER_LISTINGS, API_SECTION_REMITT_1, API_SECTION_REMITT_GETDETAILS
} from '../../Constants';
import useStyles from './detailFormStyles';

const PAN_FRONT_KEY = 'pancard_front';
const PASSPORT_BACK_KEY = 'passport_back';
const PASSPORT_FRONT_KEY = 'passport_front';
let updateInitialState = {}
updateInitialState[PAN_FRONT_KEY] = false;
updateInitialState[PASSPORT_BACK_KEY] = false;
updateInitialState[PASSPORT_FRONT_KEY] = false;

export const DragDropInput = React.memo(props => (<FormControl error={props.errors[props.id] || false}>
  <DnD {...props} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>))

export default () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  // const [formData, setFormData] = useState([]);
  const [agreementCheck, setAgreementCheck] = useState(true);
  const [agreementCheck2, setAgreementCheck2] = useState(true);
  const [errors, setErrors] = useState({});
  const [docsumoProcessing, setDocsumoProcessing] = useState(false);
  const [showDetailsSaved, setShowDetailsSaved] = useState(false);
  // const [docsUpdated, setDocsUpdated] = useState(updateInitialState);
  const [detailsNotSaved, showDetailsNotSaved] = useState(false);
  const {selectedTraveler, setSelectedTraveler, formData, setFormData, remit_id, setMainTravellerDone} = useContext(RemittanceContext);
  const {setViewSnackbar} = useContext(AppContext);

  const nameSetFromPassport = useRef(false);

  let {index} = selectedTraveler
  devConsolelog('remit detailForm render ', formData, activeStep, selectedTraveler.index)
  let {
    name="", travellerId=null, docsUpdated={},
    passport_number, pancard_number, passport_front, passport_back, passport_issue_date, passport_expiry_date, passport_issue_place,
    passport_issuedToPersonName, pancard_front, passport_front_id, passport_back_id, pancard_front_id
  } = formData[activeStep] || {}
  devConsolelog('remit detailForm render 2 ', name, passport_number, pancard_number)

  useEffect(() => {
    setActiveStep(index)
  }, [selectedTraveler])

  const handleInputField = (event, type) => {
      let val = event.target.value;
      let newState = [...formData]
      newState[activeStep][type] = val;
      setFormData(newState);
  }


  const handleNextTraveler = () => {
    if(showDetailsSaved) setShowDetailsSaved(false);
    let newIndex = index
    console.log('remit handleNextPrevTraveler next initial ', newIndex);
    if(index >= (formData.length - 1) ) newIndex = 0;
    else newIndex += 1
    console.log('remit handleNextPrevTraveler next ', newIndex);
    setSelectedTraveler({...formData[newIndex], index: newIndex})

    // () => setSelectedTraveler(travelerData[index] < (travelerData.length - 1) ? index + 1: 0)
  }

  const handleSaveTravelerDetails = async () => {
    if(!validate()) return;
    await saveFilesDetails();
  }




  const saveFilesDetails = async () => {
    let promises = [], postUrl = `${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_REMITT_1}${remit_id}${API_SECTION_REMITT_GETDETAILS}`;
    let document_ids = [];
    devConsolelog('remitt promises docsUpdated', passport_front_id, docsUpdated, formData[activeStep])
    Object.keys(docsUpdated).forEach((item, index) => {
      if(item == PASSPORT_FRONT_KEY) {
        // let pass_front_formdata = new FormData();
        let pass_front_formdata = {}
        if(docsUpdated[PASSPORT_FRONT_KEY]) {
          document_ids.push(passport_front_id);
          // pass_front_formdata.append('file', passport_front);
        }
        if(!passport_number) return;
        devConsolelog('remit promises Pass Front')
        // if(!passport_front_id) return ; //handle err
        // pass_front_formdata.append('booking_code', remit_id);
        pass_front_formdata["id_number"] = passport_number || null;
        // .append('id_number', passport_number || null);
        pass_front_formdata["issued_to_person_name"] = passport_issuedToPersonName || null;
        // .append('issued_to_person_name', passport_issuedToPersonName || null);
        pass_front_formdata["issue_date"] = passport_issue_date || null;
        // .append('issue_date', passport_issue_date || null);
        pass_front_formdata["expiry_date"] = passport_expiry_date || null;
        // .append('expiry_date', passport_expiry_date || null);
        pass_front_formdata["issue_place"] = passport_issue_place || null;
        // .append('issue_place', passport_issue_place || null);
        promises.push(
          postApi(
            `${postUrl}/${passport_front_id}`,
            pass_front_formdata,
            {},
            "patch"
          )
        )
      }
      else if(item == PASSPORT_BACK_KEY) {
        // let pass_back_formdata = new FormData();
        if(docsUpdated[PASSPORT_BACK_KEY]) {
          document_ids.push(passport_back_id);
          // pass_back_formdata.append('file', passport_back);
        }
      }
      else if(item == PAN_FRONT_KEY) {
        let pan_front_formdata = {};  //new FormData();
        if(docsUpdated[PAN_FRONT_KEY]) {
          document_ids.push(pancard_front_id);
          // pan_front_formdata.append('file', pancard_front);
        }
        if(!pancard_number || !pancard_front_id) return;
        devConsolelog('remit promises PanCard Front', pancard_front_id)
        // if(!pancard_front_id) return ; //handle err
        // pan_front_formdata.append('booking_code', remit_id);
        pan_front_formdata["id_number"] = pancard_number;
        // .append('id_number', pancard_number);
        promises.push(
          postApi(
            `${postUrl}/${pancard_front_id}`,
            pan_front_formdata,
            {},
            "patch"
          )
        )
      }
    })
    if(travellerId === null) {
      devConsolelog('remitt promises travellerId post call ', travellerId)
      let postData = {
        name,
        is_main_traveller: activeStep === 0 ? true : false,
        document_ids
      }
      promises.push(
        postApi(
          `${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_REMITT_1}${remit_id}${API_SECTION_REMITT_TRAVELERS}`,
          postData
        )
      );
    }

    // let {data, err} = await
    console.log('remit promises final ', promises);
    if(promises.length <= 0) return;
    Promise.all(promises)
    .then(result => {
      devConsolelog('remitt promises result', result)
      if(travellerId === null) {
        //post call response to create traveller
        let newTravellerData = result[result.length - 1];
        let {data = {}} = newTravellerData;
        if(data.id) updateTravellerId(data.id);
        if(activeStep === 0) setMainTravellerDone(true);
      }
      updateFormData({docsUpdated: updateInitialState})
      setShowDetailsSaved(true);
    })
    .catch(e => {
      setViewSnackbar({message: 'Something went wrong..', type: 'error'})
    })
  }

  const updateTravellerId = (id = null) => {
    // activeStep + 1
    if(!formData[activeStep] || formData[activeStep].id) return;
    // formData[activeStep + 1]["id"] = id;
    updateFormData({ travellerId: id });
    devConsolelog("traveller id updated! ", id);
  }

  const onDndDocChange = (documents = {}, type = null) => {
    let newDocsUpdated = {...docsUpdated}
    console.log('got documents; ', documents, type, newDocsUpdated);
    newDocsUpdated[type] = true;
    // setDocsUpdated(newDocsUpdated);
    updateFormData({docsUpdated: newDocsUpdated})
    getDocsumoData(documents, type);
  }

  const getDocsumoData = async (documents, type) => {
    // setDocsumoProcessing(true);
    let fileName = Object.keys(documents);
    if(fileName.length > 0) fileName = fileName[0]
    let file = documents[fileName]
    let formdata = new FormData();
    formdata.append("files", file);
    if(type == `${PAN_FRONT_KEY}`) {
      setDocsumoProcessing(`${PAN_FRONT_KEY}`);
      let {data = {}, status, err = null} = await postApi(`${API_DOCSUMO_PAN}`, formdata, {"X-API-KEY": `${DOCSUMO_APIKEY}`})
      if(err) {
        setViewSnackbar({message: 'Something went wrong!', type: 'error'})
        setDocsumoProcessing(false);
      }
      console.log('pan response ', data);
      let {meta_data = {}, data:results = {}} = data;
      if(meta_data.review_required) {
        //
      }
      let {pan = {}, name = {}} = results
      let updateData = {
        pancard_number: pan.value,
        // name: name.value,
        pancard_front: file,
        pancard_front_id: file.id || null
      }
      // prioritize passport name, if not available set rom pan
      if(!nameSetFromPassport.current) updateData["name"] = name.value;

      updateFormData(updateData);
    } else if(type == `${PASSPORT_FRONT_KEY}`) {
      setDocsumoProcessing(`${PASSPORT_FRONT_KEY}`);
      let {data = {}, status, err = null} = await postApi(`${API_DOCSUMO_PASSPORT_FRONT}`, formdata, {"X-API-KEY": `${DOCSUMO_APIKEY}`})
      if(err) {
        setViewSnackbar({message: 'Something went wrong!', type: 'error'})
        setDocsumoProcessing(false);
      }
      console.log('passport front response ', data);
      let {meta_data = {}, data:results = {}} = data;
      if(meta_data.review_required) {
        //
      }
      let {passport_no = {}, given_name = {}, issue_date = {}, issue_place = {}, expiry_date= {}} = results;

      updateFormData({
        passport_number: passport_no.value,
        name: given_name.value,
        passport_issuedToPersonName: given_name.value,
        passport_issue_date: issue_date.value,
        passport_issue_place: issue_place.value,
        passport_expiry_date: expiry_date.value,
        passport_front: file,
        passport_front_id: file.id || null
      })
      nameSetFromPassport.current = true;
    } else if(type == `${PASSPORT_BACK_KEY}`) {
      setDocsumoProcessing(`${PASSPORT_BACK_KEY}`);
      // await timeout(2000);
      devConsolelog('remitt dnd no process')
      updateFormData({passport_back: file, passport_back_id: file.id || null})
    }
    setDocsumoProcessing(false)
  }

  const updateFormData = (values = {}) => {
    devConsolelog("updateFormData ", values)
    let newState = [...formData];
    for(let i in values) {
      newState[activeStep][i] = values[i];
    }
    setFormData(newState);
  }

  const validate = () => {
      let error = {};
      // checkDateExpiration();
      let missing_fields = {
        name: '',
        // passport_issuedToPersonName: '',
        passport_number: '',

        // pancard_front: '',
        passport_issue_date: '',
        passport_expiry_date: '',
        passport_issue_place: ''
      }
      if(activeStep === 0) missing_fields["pancard_number"] = '';

      let missing_doc_fields = {
        passport_front: '',
        passport_back: '',
      }

      if(formData[activeStep]['passport_front'] || formData[activeStep]['passport_back']) {
        missing_doc_fields = {};
      }
      if(activeStep === 0) missing_doc_fields.pancard_front = '';

      for (let field in missing_fields) {
        console.log("error missing_fields ", field, formData[activeStep][field]);
        // let val = formData[activeStep][field];
        // try {
        //   val = formData[activeStep][field].trim()
        // } catch (e) {
        //   val = formData[activeStep][field];
        //   console.log('error validate ', field, val)
        // }
        // formData[activeStep][field] === undefined && formData[activeStep][field] === null &&
        try {
          if (!formData[activeStep][field] && !(formData[activeStep][field].trim())) {
            // error.push([field, 'Please enter a value'])
            error[field] = 'Please enter a value';
          }

        } catch (e) {
          console.log('error validate missing_fields ', field, formData[activeStep][field]);
          setViewSnackbar({message: `error missing_fields ${field} ${formData[activeStep][field]}`});
        }
      }

      for (let field in missing_doc_fields) {
        if (!formData[activeStep][field]) {
            // error.push([field, 'Please enter a value'])
            error[field] = 'Please upload file!';
        }
      }
      if(!agreementCheck) error["agreementCheck"] = "Please select this checkbox to save details."
      if(!agreementCheck2) error["agreementCheck2"] = "Please select this checkbox to save details."

      setErrors(error);
      let errorKeys = Object.keys(error);
      if(errorKeys.length > 0) {
        console.log("validate errors: ", error, errorKeys[0]);
        let elem = document.getElementById(errorKeys[0]);
        if(elem) elem.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        return false;
      } else return true;

  }

  const RemitDnd = (props) => {
    if(docsumoProcessing && props.type ===  docsumoProcessing)
      return (<div className={classes.processingLoader}>
        <StyledCircularProgress />
        <Typography variant="p">processing...</Typography>
      </div>)
    else {
      let postParams={
        booking_code: remit_id,
      }
      if(travellerId !== null) postParams["traveller"] = travellerId;
      if(props.type === PAN_FRONT_KEY) {
        postParams["type"] = "pan";
        postParams["page_type"] = "front";
      } else if(props.type === PASSPORT_BACK_KEY) {
        postParams["type"] = "passport";
        postParams["page_type"] = "back";
      } else if(props.type === PASSPORT_FRONT_KEY) {
        postParams["type"] = "passport";
        postParams["page_type"] = "front";
      }

      return (<DragDropInput
        {...props}
        formType="remittance"
        postUrl={`${API_DOMAIN_URL_RESELLER}${API_SECTION_RESELLER_LISTINGS}${API_SECTION_REMITT_1}${remit_id}${API_SECTION_REMITT_GETDETAILS}`}
        postParams={postParams}
        file_type="documents"
      />)
    }
  }

  const removeDocument = (type = null) => {
    if(!type) return;
    let newState = {}, newDocsUpdated = {...docsUpdated};
    // newState[activeStep][type] = null
    newState[type] = null
    newDocsUpdated[type] = true;
    if(type === PASSPORT_FRONT_KEY) {
      newState[passport_front_id] = null;
    }
    if(type === PASSPORT_BACK_KEY) {
      newState[passport_back_id] = null;
    }
    if(type === PAN_FRONT_KEY) {
      newState[pancard_front_id] = null;
    }
    updateFormData(newState);
    // setDocsUpdated(newDocsUpdated);
    updateFormData({docsUpdated: newDocsUpdated})
  }

  const handleBack = () => {
    let backOk = true;
    for(let key in docsUpdated) {
      if(docsUpdated[key]) {
        // setShowNotSaved(true);
        showDetailsNotSaved(true);
        backOk = false;
        break;
      }
    }
    if(backOk) setSelectedTraveler(null);
  }

  const handleModalSave = () => {
    showDetailsNotSaved(false)
    handleSaveTravelerDetails();
  }

  const MandatoryPointer = () => <span style={{color: 'red'}}>*</span>

  return (<div>
    <Typography align="center" variant="h5" color="textSecondary" gutterBottom="true">Traveller {activeStep + 1} out of {formData.length}</Typography>

    <div className={classes.container}>
      <div className={classes.docSec}>
        <Typography variant="h6" color="secondary">Step 1. Upload Documents</Typography>
        <div className={classes.docsWrapper}>
          <div>
            <Typography className={classes.dndTitle} color="textSecondary" variant="h6">1. Passport Front Copy {<MandatoryPointer />} (compulsory)</Typography>
            {
              passport_front == null
              ? <RemitDnd type={`${PASSPORT_FRONT_KEY}`} defaultMsg="UPLOAD PASSPORT FRONT SIDE" documents={passport_front} id="passport_front" onDndDocChange={(data) => onDndDocChange(data, `${PASSPORT_FRONT_KEY}`)} errors={errors}/>
              : (<div className={classes.fillDataDnd}>
                <div><span key={index}><Attachment style={{height: 16}} /><a href={'#'}>{passport_front && getFileNameFromUrl(passport_front.name)}</a></span> <br /><Button color="secondary" onClick={(e) => removeDocument(`${PASSPORT_FRONT_KEY}`, e)}>Remove</Button></div>
              </div>)
            }
          </div>
          <Divider variant="middle" />
          <div>
            <Typography className={classes.dndTitle} color="textSecondary" variant="h6">2. Passport Back Copy</Typography>
            {
              passport_back == null
              ? <RemitDnd type={`${PASSPORT_BACK_KEY}`} defaultMsg="UPLOAD PASSPORT BACK SIDE" documents={passport_back} id="passport_back" onDndDocChange={(data) => onDndDocChange(data, `${PASSPORT_BACK_KEY}`)} errors={errors}/>
              : (<div className={classes.fillDataDnd}>
                <div><span key={index}><Attachment style={{height: 16}} /><a href={'#'}>{passport_back && getFileNameFromUrl(passport_back.name)}</a></span> <br /><Button color="secondary" onClick={(e) => removeDocument(`${PASSPORT_BACK_KEY}`, e)}>Remove</Button></div>
              </div>)
            }
          </div>
          <Divider variant="middle" />
          <div>
          <Typography className={classes.dndTitle} color="textSecondary" align="left" variant="h6">3. Pan Card {activeStep === 0 && (<><MandatoryPointer /> (compulsory)</>)}</Typography>
            {
              pancard_front == null
              ? <RemitDnd type={`${PAN_FRONT_KEY}`} defaultMsg="UPLOAD PANCARD SIDE" documents={pancard_front} id="pancard_front" onDndDocChange={(data) => onDndDocChange(data, `${PAN_FRONT_KEY}`)} errors={errors} />
              : (<div className={classes.fillDataDnd}>
                <div><span key={index}><Attachment style={{height: 16}} /><a href={'#'}>{pancard_front && getFileNameFromUrl(pancard_front.name)}</a></span> <br /><Button color="secondary" onClick={(e) => removeDocument(`${PAN_FRONT_KEY}`, e)}>Remove</Button></div>
              </div>)
            }
          </div>
        </div>
      </div>
      <div><Divider orientation="vertical" variant="middle" /></div>
      <div className={classes.detailsSec}>
        <Typography variant="h6" color="secondary">Step 2. Confirm Details</Typography>
        <TextInput errors={errors} id="name" value={name} className={classes.margin} label="NAME" onChange={(e) => handleInputField(e, "name")} variant="outlined" type="text" />
        <Divider variant="middle" />
        <TextInput errors={errors} id="passport_number" value={passport_number} className={classes.margin} label="PASSPORT NUMBER" onChange={(e) => handleInputField(e, "passport_number")} variant="outlined" type="text" />
        <TextInput errors={errors} id="passport_issue_date" value={passport_issue_date} className={classes.margin} label="PASSPORT ISSUE DATE" onChange={(e) => handleInputField(e, "passport_issue_date")} variant="outlined" type="text" />
        <TextInput errors={errors} id="passport_expiry_date" value={passport_expiry_date} className={classes.margin} label="PASSPORT EXPIRY DATE" onChange={(e) => handleInputField(e, "passport_expiry_date")} variant="outlined" type="text" />
        <TextInput errors={errors} id="passport_issue_place" value={passport_issue_place} className={classes.margin} label="PASSPORT ISSUE PLACE" onChange={(e) => handleInputField(e, "passport_issue_place")} variant="outlined" type="text" />
        <Divider variant="middle"/>
        <TextInput errors={errors} id="pancard_number" value={pancard_number} defaultValue={pancard_number} className={classes.margin} label="PANCARD NUMBER" onChange={(e) => handleInputField(e, "pancard_number")} variant="outlined" type="text" />
      </div>
    </div>

    <FormControlLabel
      control={
        <CheckboxInput
          checked={agreementCheck}
          id={"agreementCheck"}
          onChange={() => setAgreementCheck(!agreementCheck)}
          errors={errors}
          className={classes.checkBoxInput}
        />
      }
      className={classes.checkbox}
      label="I confirm that the details fetched in Step 2 are correct and can be used for Documentation purposes."
    />
    <FormControlLabel
      control={
        <CheckboxInput
          checked={agreementCheck2}
          id={"agreementCheck2"}
          onChange={() => setAgreementCheck2(!agreementCheck2)}
          errors={errors}
          className={classes.checkBoxInput}
        />
      }
      className={classes.checkbox}
      label="I confirm that the details fetched in Step 2 are true and correct and that this remittance along with any other previous remittance for this financial year does not exceed the LRS limit allowed as per RBI guidelines for this traveller."
    />
    <div className={classes.actionsContainer}>
      <StyledButton2 onClick={handleBack}>Back</StyledButton2>
      {/** index > 0 && (<StyledButton2 onClick={handlePrevTraveler}>Prev</StyledButton2>) **/}
      <StyledButton2 onClick={handleSaveTravelerDetails}>
        { index < formData.length - 1 ? 'Save' : 'Submit' }
      </StyledButton2>
      {/** index === formData.length - 1 && (<StyledButton2 >Submit</StyledButton2>) **/}
    </div>
    {
      showDetailsSaved && (<MyDailogModal
      titleText={`Traveller ${activeStep + 1} details saved!`}
      bodyText={<CheckCircleOutline className={classes.savedIcon} />}
      actions={
        activeStep < formData.length - 1
        ? [
          {
            name: "Next Traveller",
            onClick: handleNextTraveler
          }
        ]
        : []
      }
      openDailog={true}
      fullScreen={false}
      onClose={() => setShowDetailsSaved(false)}
    />)}
    {
      detailsNotSaved && (<MyDailogModal
        titleText={`Traveller ${activeStep + 1} details NOT saved!`}
        bodyText={<Typography variant="h5" color="textSecondary">Please save or the data may be lost.</Typography>}
        actions={[
          {
            name: "Save",
            onClick: handleModalSave
          }
        ]}
        openDailog={true}
        fullScreen={false}
        onClose={() => showDetailsNotSaved(false)}
      />)
    }

  </div>);
}
